/* tm-spielplan-widget — Design-Tokens & Komponentenstile
   Aesthetik: Quotentafel/Anzeigetafel im Stadion, nicht generisches Web-UI.
   Ziffern durchgehend in Monospace (Zeit, Quoten, Ergebnis) für saubere Ausrichtung. */

@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&family=Inter:wght@400;500;600&display=swap');

:host {
  display: block;
  box-sizing: border-box;

  --tm-height:100%;
  --tm-bg: #F4F8FA;
  --tm-surface: #FFFFFF;
  --tm-surface-alt: #CFE9F3;
  --tm-ink: #16232B;
  --tm-muted: #4A5A64;
  --tm-border: #B9CBD3;
  --tm-accent: #0B6E9E;
  --tm-accent-ink: #FFFFFF;
  --tm-accent-soft: #B9E0EF;
  --tm-live: #C8432A;
  --tm-live-soft: #FBEAE5;
  --tm-radius: 10px;
  --tm-radius-main: 14px;
  --tm-padding: 0.85rem;
  --tm-shadow: 0 1px 2px rgba(22, 35, 43, 0.06), 0 1px 1px rgba(22, 35, 43, 0.04);
  --tm-shadow-kopf: 0 1px 2px rgba(22, 35, 43, 0.06), 0 1px 1px rgba(22, 35, 43, 0.04);
  --tm-padding-kopf:  0.6rem;
  --tm-border-kopf:none;
  --tm-story-row-bg:#10202f;
  --tm-story-row-padding: 0.85rem 1rem 0.85rem 0;
  --tm-story-row-border-radius: 12px;
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  color: var(--tm-ink);

  --tm-liveticker-bg: transparent;
  --tm-liveticker-color-1:black;
  --tm-liveticker-color-2: #4a5a64;
}

.tm-spielplan {
  background: var(--tm-bg);
  padding: var(--tm-padding);
  border-radius: var(--tm-radius-main);
  width: 100%;
  height: var(--tm-height);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.tm-kopf-bereich {
  flex-shrink: 0;
  background: var(--tm-surface);
  border-radius: calc(var(--tm-radius) + 2px);
  padding: var(--tm-padding-kopf);
  margin-bottom: 0.6rem;
  box-shadow: var(--tm-shadow-kopf);
  border: var(--tm-border-kopf);
}

.tm-inhalt-bereich {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.tm-spielplan--vollbild {
  position: fixed;
  inset: 0;
  z-index: 999999;
  max-width: none;
  border-radius: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.tm-vollbild-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--tm-border);
  border-radius: 8px;
  background: var(--tm-surface);
  color: var(--tm-muted);
  cursor: pointer;
  flex-shrink: 0;
}

.tm-vollbild-btn:hover {
  color: var(--tm-accent);
  border-color: var(--tm-accent);
}

.tm-vollbild-btn:focus-visible {
  outline: 2px solid var(--tm-accent);
  outline-offset: 1px;
}

.tm-day-nav {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.35rem 0.6rem;
  background: var(--tm-bg);
  border: 1px solid var(--tm-border);
  border-radius: 8px;
}

.tm-day-nav-1 {
  display:flex;
  gap:4px;
  align-items: center;
}

.tm-day-nav-2 {
  display:flex;
  flex:1;
  gap:4px;
  justify-content:right;
}

.tm-day-nav__btn {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--tm-border);
  border-radius: 6px;
  background: var(--tm-surface);
  color: var(--tm-ink);
  font-size: 1.1rem;
  line-height: 1;
  cursor: pointer;
}

.tm-day-nav__btn:hover:not(:disabled) {
  border-color: var(--tm-accent);
  color: var(--tm-accent);
}

.tm-day-nav__btn:disabled {
  opacity: 0.3;
  cursor: default;
}

.tm-day-nav__btn:focus-visible {
  outline: 2px solid var(--tm-accent);
  outline-offset: 1px;
}

.tm-day-nav__label {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 1.05rem;
  flex: 1;
  text-align: center;
}

.tm-day-nav__today {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--tm-border);
  border-radius: 6px;
  background: var(--tm-accent-soft);
  color: var(--tm-accent);
  font-size: 0.85rem;
  line-height: 1;
  cursor: pointer;
}

.tm-day-nav__today:hover {
  background: var(--tm-accent);
  color: var(--tm-accent-ink);
}

.tm-day-nav__today:focus-visible {
  outline: 2px solid var(--tm-accent);
  outline-offset: 1px;
}

.tm-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
  margin-bottom: 0.5rem;
}

.tm-search {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1 1 80px;
  min-width: 0;
}

.tm-search__icon {
  position: absolute;
  left: 0.5rem;
  width: 14px;
  height: 14px;
  color: var(--tm-muted);
  pointer-events: none;
}

.tm-search__input {
  padding: 0.4rem 1.8rem 0.4rem 1.8rem;
  border: 1px solid var(--tm-border);
  border-radius: 8px;
  font-family: inherit;
  font-size: 0.8rem;
  width: 100%;
  min-width: 0;
  background: var(--tm-surface);
  color: var(--tm-ink);
}

.tm-search__input:focus-visible {
  outline: 2px solid var(--tm-accent);
  outline-offset: 1px;
}

.tm-search__input::placeholder {
  color: var(--tm-muted);
}

.tm-search__clear {
  position: absolute;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background: var(--tm-border);
  color: var(--tm-surface);
  font-size: 0.6rem;
  line-height: 1;
  cursor: pointer;
  flex-shrink: 0;
}

.tm-search__clear:hover {
  background: var(--tm-muted);
}

.tm-liga-dropdown__trigger {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 0.6rem;
  border: 1px solid var(--tm-border);
  border-radius: 8px;
  font-family: inherit;
  font-size: 0.8rem;
  font-weight: 500;
  background: var(--tm-surface);
  color: var(--tm-ink);
  cursor: pointer;
  flex: 0 1 130px;
  min-width: 90px;
}

.tm-liga-dropdown__trigger:hover {
  border-color: var(--tm-accent);
}

.tm-liga-dropdown__trigger:focus-visible {
  outline: 2px solid var(--tm-accent);
  outline-offset: 1px;
}

.tm-liga-dropdown__flagge {
  width: 18px;
  height: auto;
  flex-shrink: 0;
  border-radius: 2px;
}

.tm-liga-dropdown__flagge-platzhalter {
  width: 18px;
  height: 13px;
  flex-shrink: 0;
}

.tm-liga-dropdown__label {
  flex: 1;
  min-width: 0;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tm-liga-dropdown__pfeil {
  width: 12px;
  height: 12px;
  color: var(--tm-muted);
  flex-shrink: 0;
}

.tm-liga-dropdown__panel {
  display: flex;
  flex-direction: column;
  background: var(--tm-surface);
  border: 1px solid var(--tm-border);
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(16, 24, 30, 0.15);
  padding: 0.4rem;
  max-height: 320px;
  overflow-y: auto;
  z-index: 100;
}

.tm-liga-dropdown__panel--teleportiert {
  position: fixed;
  top: 0;
  left: 0;
}

.tm-liga-dropdown__option {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.4rem 0.5rem 0.6rem;
  border: none;
  border-radius: 6px;
  background: none;
  color: var(--tm-ink);
  font-family: inherit;
  font-size: 0.85rem;
  text-align: left;
  cursor: pointer;
  white-space: nowrap;
  width: 100%;
}

.tm-liga-dropdown__option:hover {
  background: var(--tm-surface-alt);
}

.tm-liga-dropdown__option--aktiv {
  background: var(--tm-accent-soft);
  color: var(--tm-accent);
  font-weight: 600;
}

.tm-liga-dropdown__favorit-btn {
  border: none;
  background: none;
  color: var(--tm-border);
  font-size: 1rem;
  line-height: 1;
  cursor: pointer;
  padding: 0 0.15rem;
  margin-left: auto;
  flex-shrink: 0;
}

.tm-liga-dropdown__favorit-btn--aktiv {
  color: #F5C518;
}

.tm-chips {
  display: flex;
  gap: 0.35rem;
  flex-wrap: wrap;
}

.tm-chip {
  padding: 0.35rem 0.75rem;
  border: 1px solid var(--tm-border);
  border-radius: 999px;
  background: var(--tm-surface);
  color: var(--tm-ink);
  font-family: inherit;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

.tm-chip:hover {
  border-color: var(--tm-accent);
}

.tm-chip:focus-visible {
  outline: 2px solid var(--tm-accent);
  outline-offset: 1px;
}

.tm-chip--active {
  background: var(--tm-accent);
  border-color: var(--tm-accent);
  color: var(--tm-accent-ink);
}

.tm-toggle {
  display: flex;
  margin-left: auto;
  border: 1px solid var(--tm-border);
  border-radius: 8px;
  overflow: hidden;
}

.tm-toggle__btn {
  padding: 0.4rem 0.6rem;
  border: none;
  background: var(--tm-surface);
  color: var(--tm-muted);
  font-family: inherit;
  font-size: 0.78rem;
  font-weight: 500;
  cursor: pointer;
  border-left: 1px solid var(--tm-border);
}

.tm-toggle__btn:first-child {
  border-left: none;
}

.tm-toggle__btn:focus-visible {
  outline: 2px solid var(--tm-accent);
  outline-offset: -2px;
}

.tm-toggle__btn--active {
  background: var(--tm-accent-soft);
  color: var(--tm-accent);
}

.tm-state {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 12px 1rem;
  justify-content: center;
  color: var(--tm-muted);
  font-size: 0.9rem;
}

.tm-state--error {
  color: var(--tm-live);
}

.tm-state--column {
  flex-direction: column;
  gap: 0.75rem;
  text-align: center;
}

.tm-retry-btn {
  padding: 0.4rem 1rem;
  border: 1px solid var(--tm-live);
  border-radius: 8px;
  background: var(--tm-surface);
  color: var(--tm-live);
  font-family: inherit;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
}

.tm-retry-btn:hover {
  background: var(--tm-live-soft);
}

.tm-state__spinner {
  width: 14px;
  height: 14px;
  border: 2px solid var(--tm-border);
  border-top-color: var(--tm-accent);
  border-radius: 50%;
  animation: tm-spin 0.7s linear infinite;
}

@media (prefers-reduced-motion: reduce) {
  .tm-state__spinner { animation: none; }
}

@keyframes tm-spin {
  to { transform: rotate(360deg); }
}

.tm-group {
  margin-bottom: 0.85rem;
}

.tm-group__heading {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 1.05rem;
  letter-spacing: 0.01em;
  color: var(--tm-ink);
  margin: 0 0 0.4rem;
  padding-bottom: 0.3rem;
  border-bottom: 2px solid var(--tm-accent-soft);
}

.tm-card-list {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.tm-card {
  background: var(--tm-surface);
  border: 1px solid var(--tm-border);
  border-radius: var(--tm-radius);
  box-shadow: var(--tm-shadow);
  padding: 0.55rem 0.75rem;
  border-left: 3px solid var(--tm-border);
}

.tm-card--live {
  border-left-color: var(--tm-live);
  background: var(--tm-live-soft);
}

.tm-card--beendet {
  border-left-color: var(--tm-accent);
}

.tm-card--bald {
  border-left-color: var(--tm-accent);
  border-left-style: dashed;
}

.tm-card__meta {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.3rem;
  font-family: 'Poppins', sans-serif;
  font-size: 0.72rem;
  color: var(--tm-muted);
}

.tm-card__time {
  font-variant-numeric: tabular-nums;
  font-weight: 700;
}

/* Datum bei mehrtägigen Listen (z.B. Team-Suche über alle Tage) - gleicher Stil wie
   .tm-card__time, damit's sich optisch als "gehört zur Zeit-Angabe" liest. */
.tm-card__datum {
  font-variant-numeric: tabular-nums;
}

.tm-card__liga {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  font-family: 'Inter', sans-serif;
  background: var(--tm-surface-alt);
  color: var(--tm-accent);
  padding: 0.1rem 0.5rem;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 600;
}

.tm-card__liga-logo {
  width: 14px;
  height: 14px;
  object-fit: contain;
  flex-shrink: 0;
}

.tm-card__status {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  letter-spacing: 0.02em;
  font-size: 0.7rem;
  padding: 0.2rem 0.6rem;
  border-radius: 999px;
  background: var(--tm-surface-alt);
}

.tm-card__status--live { color: var(--tm-live); background: var(--tm-live-soft); }
.tm-card__status--beendet { color: var(--tm-accent); background: var(--tm-accent-soft); }
.tm-card__status--geplant { color: var(--tm-muted); background: var(--tm-surface-alt); }
.tm-card__status--bald { color: var(--tm-accent); background: var(--tm-accent-soft); font-weight: 400; }

.tm-live-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--tm-live);
  animation: tm-pulse 1.4s ease-in-out infinite;
}

@media (prefers-reduced-motion: reduce) {
  .tm-live-dot { animation: none; }
}

@keyframes tm-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.35; }
}

.tm-card__main {
  display: flex;
  align-items: stretch;
  gap: 0.5rem;
}

.tm-card__block {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  flex-shrink: 0;
}

.tm-card__block--teams {
  flex: 1 1 auto;
  gap: .55rem;
  min-width: 0;
  margin-top: 5px;
}

.tm-card__block--quoten {
  align-items: center;
  justify-content: center;
  gap: 0.15rem;
}

.tm-card__block--sterne {
  align-items: center;
  justify-content: space-between;
}

.tm-card__block--sterne span {
  flex:1;
}

.tm-card__block--resultat {
  align-items: flex-end;
  justify-content: space-between;
}

.tm-team {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
}

.tm-team__logo {
  width: 22px;
  height: 22px;
  object-fit: contain;
  flex-shrink: 0;
}

.tm-team__logo--platzhalter {
  display: inline-block;
  background: var(--tm-surface-alt);
  border-radius: 50%;
}

.tm-team__name {
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size:14px;
  line-height:18px;
  color: var(--tm-ink);
  opacity: 0.85;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.tm-team-row__score {
  font-family: 'Poppins', sans-serif;
  font-size: 1.1rem;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: var(--tm-ink);
  flex-shrink: 0;
  line-height: 1.4;
}

.tm-card--beendet .tm-team-row__score {
  color: var(--tm-ink);
  font-weight: 600;
}

.tm-quote-zeile {
  display: flex;
  align-items: center;
  gap: 0.36rem;
  line-height:1.3;
}

.tm-quote-zeile__label {
  font-family: 'Inter', sans-serif;
  font-size: 0.62rem;
  font-weight: 600;
  color: var(--tm-muted);
  text-transform: uppercase;
  width: 0.7rem;
  text-align: center;
  flex-shrink: 0;
}

.tm-quote-zeile__wert {
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  color: var(--tm-muted);
  flex-shrink: 0;
  min-width: 2.4rem;
}

.tm-quote-zeile__wert--favorit {
  color: var(--tm-accent);
  font-weight: 700;
}

@media (max-width: 641px) {
  .tm-team__name {
    font-size:14px;
  }
}

.tm-footer {
  margin-top: 0.5rem;
  font-family: 'Poppins', sans-serif;
  font-size: 0.68rem;
  color: var(--tm-muted);
}
/*
@media (min-width: 641px) {
  :host {
    max-width: 460px;
  }
}*/

@media (max-width: 640px) {
  .tm-search__input {
    width: 100%;
    box-sizing: border-box;
  }

  .tm-card__meta {
    flex-wrap: wrap;
    row-gap: 0.3rem;
  }

  .tm-card__status {
    margin-left: 0;
  }

  .tm-day-nav__label {
    font-size: 0.9rem;
  }
}

.tm-card__aktionen {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem;
  margin-top: 0.4rem;
  padding-top: 0.4rem;
  border-top: 1px solid var(--tm-border);
}

.tm-aktion-btn {
  flex: 0 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  padding: 0.4rem 0.7rem;
  border: 1px solid var(--tm-border);
  border-radius: 8px;
  background: var(--tm-surface-alt);
  color: var(--tm-accent);
  font-family: inherit;
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
}

.tm-aktion-btn--vorschau {
  background: var(--tm-accent);
  color: var(--tm-accent-ink);
  border-color: var(--tm-accent);
}

.tm-aktion-btn__icon {
  font-size: 0.95rem;
  line-height: 1;
  flex-shrink: 0;
}

.tm-aktion-btn__label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 400px) {
  .tm-aktion-btn {
    flex: 0 0 auto;
    width: 2.4rem;
    padding: 0.4rem 0;
  }
  .tm-aktion-btn__label {
    display: none;
  }
}

.tm-aktion-btn:hover {
  border-color: var(--tm-accent);
}

.tm-sheet-backdrop {
  position: fixed;
  inset: 0;
  z-index: 999999;
  background: rgba(16, 24, 30, 0.5);
}

.tm-tab-titel {
  padding: 0px 0px 14px;
  font-size: 14px;
  font-weight: 700;
  color: #1a1a1a;
}

.tm-detail-overlay,
.tm-scroll-bereich {
  overscroll-behavior: contain;
}

.tm-detail-overlay {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000000;
  background: var(--tm-surface);
  border-radius: 16px 16px 0 0;
  max-height: 88dvh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0 1rem 0;
  box-shadow: 0 -4px 24px rgba(16, 24, 30, 0.2);
  max-width: 800px;
  margin: 0 auto; 
}

.tm-tabbar {
  flex: none;
  position: relative;
  z-index: 1;
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  padding: 8px 12px calc(8px + env(safe-area-inset-bottom, 0px));
  overflow-x: auto;
  scrollbar-width: none;
  border-top: 1px solid color-mix(in srgb, currentColor 12%, transparent);
  background: inherit;
}
.tm-tabbar::-webkit-scrollbar { display: none; }

.tm-tabbar__btn {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 46px;
  height: 46px;
  padding: 0 12px;
  border: 0;
  border-radius: 999px;
  background: color-mix(in srgb, currentColor 7%, transparent);
  color: inherit;
  font: inherit;
  cursor: pointer;
}
.tm-tabbar__icon { font-size: 21px; line-height: 1; }
.tm-tabbar__label { display: none; font-size: 13px; font-weight: 700; white-space: nowrap; }

.tm-tabbar__btn--aktiv { background: color-mix(in srgb, currentColor 16%, transparent); padding: 0 16px 0 12px; }
.tm-tabbar__btn--aktiv .tm-tabbar__label { display: inline; }

.tm-detail-overlay__inhalt {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-bottom: .5rem;
}

.tm-detail-overlay__inhalt--einfach {
  overflow-y: auto;
  overflow-x: hidden;
}

.tm-detail-overlay__inhalt > .tm-vorschau {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.tm-detail-overlay__inhalt > .tm-aufstellung-tab,
.tm-detail-overlay__inhalt > .tm-h2h-tab,
.tm-detail-overlay__inhalt > .tm-ausfaelle-tab,
.tm-detail-overlay__inhalt > .tm-events,
.tm-detail-overlay__inhalt > .tm-statistik {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.tm-team-kopfzeile {
  flex-shrink: 0;
}

.tm-scroll-bereich {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.tm-detail-overlay--schmal {
  max-width: 420px;
  margin: 0 auto;
}

.tm-sheet-fade-enter-active,
.tm-sheet-fade-leave-active {
  transition: opacity 0.25s ease;
}
.tm-sheet-fade-enter-from,
.tm-sheet-fade-leave-to {
  opacity: 0;
}

.tm-sheet-slide-enter-active,
.tm-sheet-slide-leave-active {
  transition: transform 0.25s ease;
}
.tm-sheet-slide-enter-from,
.tm-sheet-slide-leave-to {
  transform: translateY(100%);
}

.tm-detail-overlay__kopf {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.75rem;
  gap:7px;
}

.tm-detail-overlay__titel {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 17px;
}

.tm-detail-overlay__tabs {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.tm-detail-overlay .tm-detail-overlay__tabs--unten {
  flex: none;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  overscroll-behavior-x: contain;
}
.tm-detail-overlay .tm-detail-overlay__tabs--unten .tm-toggle__btn { flex: none; }

/* Touch: Scrollbar versteckt */
.tm-detail-overlay .tm-detail-overlay__tabs--unten { scrollbar-width: none; }
.tm-detail-overlay .tm-detail-overlay__tabs--unten::-webkit-scrollbar { display: none; }

/* Maus: dünne Scrollbar sichtbar */
@media (hover: hover) and (pointer: fine) {
  .tm-detail-overlay .tm-detail-overlay__tabs--unten { scrollbar-width: thin; }
  .tm-detail-overlay .tm-detail-overlay__tabs--unten::-webkit-scrollbar { display: block; }
}

.tm-detail-overlay__tabs .tm-toggle__btn {
  border: 1px solid var(--tm-border);
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

.tm-toggle__icon { display: inline-flex; align-items: center; justify-content: center; }
.tm-tab-icon { display: block; }

.tm-toggle__label {
  white-space: nowrap;
}

@media (max-width: 400px) {
  .tm-detail-overlay {
    padding-left:7px;
    padding-right:7px;
  }
  .tm-detail-overlay__tabs .tm-toggle__btn {
    padding: 0.5rem;
  }
  .tm-detail-overlay__tabs .tm-toggle__label {
    display: none;
  }
}

.tm-aufstellung {
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.tm-aufstellung-team {
  flex: 1 1 260px;
  min-width: 0;
}

.tm-aufstellung-team__kopf {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.tm-aufstellung-team__name {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
}

.tm-aufstellung-formation {
  margin-left: auto;
  font-size: 0.75rem;
  color: var(--tm-muted);
  background: var(--tm-surface-alt);
  padding: 0.1rem 0.5rem;
  border-radius: 4px;
}

.tm-aufstellung-abschnitt-titel {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--tm-muted);
  margin: 0.6rem 0 0.3rem;
}

.tm-spieler-zeile {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.2rem 0;
  font-size: 0.85rem;
  border-bottom: 1px solid var(--tm-border);
}

.tm-spieler-nummer {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  color: var(--tm-muted);
  min-width: 1.5rem;
}

.tm-spieler-name {
  flex: 1;
}

.tm-spieler-pos {
  font-size: 0.7rem;
  color: var(--tm-muted);
}

.tm-aufstellung-trainer {
  margin-top: 0.6rem;
  font-size: 0.8rem;
  color: var(--tm-muted);
}

.tm-ersatz { margin-top: 16px; }
.tm-ersatz__titel { text-align: center; font-size: 12px; font-weight: 800; letter-spacing: .12em; text-transform: uppercase; opacity: .6; margin-bottom: 8px; }
.tm-ersatz__spalten { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; align-items: start; }
.tm-ersatz__liste { list-style: none; margin: 0; padding: 0; display: grid; gap: 4px; min-width: 0; }
.tm-ersatz__team { font-size: 11px; font-weight: 800; opacity: .55; padding: 0 4px 2px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.tm-ersatz__liste--rechts .tm-ersatz__team { text-align: right; }

.tm-ersatz__zeile { display: flex; align-items: center; gap: 8px; padding: 6px 8px; border-radius: 10px; background: color-mix(in srgb, currentColor 5%, transparent); border-left: 3px solid transparent; min-width: 0; }
.tm-ersatz__liste--rechts .tm-ersatz__zeile { flex-direction: row-reverse; text-align: right; border-left: 0; border-right: 3px solid transparent; }

.tm-ersatz__nr { flex: none; width: 24px; height: 24px; border-radius: 50%; display: grid; place-items: center; font-size: 12px; font-weight: 800; font-variant-numeric: tabular-nums; background: color-mix(in srgb, currentColor 12%, transparent); }
.tm-ersatz__text { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 1px; }
.tm-ersatz__name { font-size: 13px; font-weight: 600; line-height: 1.2; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
.tm-ersatz__infos { display: flex; align-items: center; gap: 6px; font-size: 12px; font-weight: 700; }
.tm-ersatz__liste--rechts .tm-ersatz__infos { justify-content: flex-end; }

/* eingewechselt */
.tm-ersatz__zeile--ein { background: color-mix(in srgb, #1d9e75 16%, transparent); border-left-color: #1d9e75; }
.tm-ersatz__liste--rechts .tm-ersatz__zeile--ein { border-right-color: #1d9e75; }
.tm-ersatz__zeile--ein .tm-ersatz__nr { background: #1d9e75; color: #fff; }
.tm-ersatz__ein { color: #1d9e75; }

.tm-pitch {
  position: relative;
  background: linear-gradient(180deg, #2E8B4F 0%, #276F41 100%);
  border-radius: 12px;
  padding: 0.6rem 0.4rem;
  margin-bottom: 0.75rem;
}

.tm-pitch-team-label {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  color: #fff;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 0.85rem;
  padding: 0.3rem 0.6rem;
}

.tm-pitch-mittellinie {
  border-top: 2px dashed rgba(255, 255, 255, 0.4);
  margin: 0.75rem 0;
}

.tm-pitch-zeile {
  display: flex;
  justify-content: space-evenly;
  margin: 0.5rem 0;
}

.tm-pitch-spieler {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.3rem;
  max-width: 4.5rem;
}

.tm-pitch-kreis-wrapper {
  position: relative;
}

.tm-pitch-tor {
  position: absolute;
  bottom: -3px;
  right: -4px;
  font-size: 0.6rem;
  line-height: 1;
  background: #fff;
  border-radius: 999px;
  padding: 1px 2px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
  white-space: nowrap;
}

.tm-pitch-karte {
  position: absolute;
  top: -2px;
  left: -2px;
  width: 8px;
  height: 11px;
  border-radius: 1px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
}

.tm-pitch-karte--gelb {
  background: #F5C518;
}

.tm-pitch-karte--rot {
  background: var(--tm-live);
}

.tm-sw-kopf { flex: none; padding: 4px 0 8px; }

.tm-sw-match { display: flex; align-items: center; justify-content: center; gap: 22px; padding-bottom: 10px; transition: gap .2s, padding .2s; }
.tm-sw-match__logo { width: 52px; height: 52px; object-fit: contain; transition: width .2s, height .2s; }
.tm-sw-match__mitte { display: flex; flex-direction: column; align-items: center; min-width: 70px; line-height: 1.15; }
.tm-sw-match__haupt { font-size: 24px; font-weight: 800; font-variant-numeric: tabular-nums; transition: font-size .2s; }
.tm-sw-match__neben { font-size: 12px; font-weight: 700; opacity: .6; }
.tm-sw-match__seite { display: flex; flex-direction: column; align-items: center; gap: 6px; }
.tm-sw-platz { font-size: 11px; font-weight: 800; opacity: .65; }
.tm-sw-kopf--kompakt .tm-sw-platz { display: none; }

.tm-sw-form { display: flex; align-items: center; gap: 4px; }
.tm-sw-form__label { font-size: 10px; font-weight: 800; letter-spacing: .06em; text-transform: uppercase; opacity: .55; margin-right: 2px; }

.tm-sw-form__p { width: 9px; height: 9px; border-radius: 50%; background: color-mix(in srgb, currentColor 30%, transparent); }
.tm-sw-form__p--S { background: #1d9e75; }
.tm-sw-form__p--N { background: #e5484d; }

/* neuestes Spiel: größer und mit Ring */
.tm-sw-form__p--neu { width: 12px; height: 12px; outline: 2px solid color-mix(in srgb, currentColor 35%, transparent); outline-offset: 1px; }

.tm-sw-kopf--kompakt .tm-sw-form__label { display: none; }

.tm-sw-kopf--kompakt .tm-sw-match { gap: 14px; padding-bottom: 6px; }
.tm-sw-kopf--kompakt .tm-sw-match__logo { width: 26px; height: 26px; }
.tm-sw-kopf--kompakt .tm-sw-match__haupt { font-size: 16px; }
.tm-sw-kopf--kompakt .tm-sw-match__neben { display: none; }

.tm-sw-switch { display: flex; gap: 4px; padding: 4px; border-radius: 14px; background: color-mix(in srgb, currentColor 7%, transparent); }
.tm-sw-switch__btn { flex: 1; min-width: 0; padding: 9px 10px; border: 0; border-radius: 10px; background: transparent; color: inherit; font: inherit; font-size: 14px; font-weight: 600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; opacity: .65; cursor: pointer;letter-spacing:0.03rem; }
.tm-sw-switch__btn--aktiv { background: var(--tm-surface); opacity: 1; font-weight: 800; box-shadow: 0 1px 4px rgba(16, 24, 30, .18); }

.tm-sw-name {
  font-size: .78rem;
  font-weight: 600;
  line-height: 1.15;
  text-align: center;
  max-width: 100%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.tm-sw-kopf--kompakt .tm-sw-name { display: none; }
.tm-pitch--einzeln .tm-pitch-team {
  margin-top: 1.6rem;
}

.tm-pitch--einzeln .tm-pitch-kreis {
  width: 1.9rem;
  height: 1.9rem;
  font-size: 0.9rem;
}

.tm-pitch--einzeln .tm-pitch-name {
  font-size: 0.7rem;
}

.tm-pitch-team-label--zentriert {
  position: absolute;
  top: 0.4rem;
  left: 0.5rem;
  padding: 0.15rem 0.5rem;
  background: rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
}

.tm-pitch-trainer--zentriert {
  justify-content: center;
}

.tm-pitch-kreis {
  width: 2.2rem;
  height: 2.2rem;
  border-radius: 50%;
  background: var(--tm-accent);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  font-size: 0.9rem;
  border: 2px solid rgba(255, 255, 255, 0.6);
}

.tm-pitch-kreis--gelb {
  border-color: #F5C518;
}

.tm-pitch-kreis--rot {
  background: var(--tm-live);
  border-color: #fff;
}

.tm-pitch-name {
  color: #fff;
  font-size: 0.68rem;
  text-align: center;
  line-height: 1.2;
}

.tm-pitch-aus {
  color: #FFD27A;
  font-weight: 600;
}

.tm-events {
  display: flex;
  flex-direction: column;
}

.tm-event-zeile {
  display: flex;
  gap: 0.5rem;
  padding: 0.4rem 0.5rem;
  border-bottom: 1px solid var(--tm-border);
  font-size: 0.82rem;
}

.tm-event-zeile--tor {
  background: var(--tm-accent-soft);
}

.tm-event-seite {
  flex: 1;
  min-width: 0;
  overflow-wrap: break-word;
  word-break: break-word;
}

.tm-event-seite--heim {
  text-align: left;
}

.tm-event-seite--auswaerts {
  text-align: right;
}

.tm-event-icon {
  font-size: 0.9rem;
}

.tm-wechsel-spalte {
  flex: 1 1 260px;
  min-width: 0;
}

.tm-wechsel-zeile {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 0.5rem;
  border-radius: 8px;
  margin-bottom: 0.3rem;
}

.tm-wechsel-zeile--aktiv {
  background: var(--tm-accent-soft);
}

.tm-wechsel-kreis {
  width: 1.8rem;
  height: 1.8rem;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  margin: 0 0.3rem;
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  font-size: 0.8rem;
  color: #16232B;
  flex-shrink: 0;
}

.tm-wechsel-name {
  flex: 1;
  font-size: 0.85rem;
}

.tm-wechsel-pos {
  font-size: 0.72rem;
  color: var(--tm-muted);
}

.tm-wechsel-ein {
  color: var(--tm-accent);
  font-weight: 600;
  font-size: 0.8rem;
}

.tm-pitch-trainer {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.4rem 0.6rem 0.1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  margin-top: 0.3rem;
}

.tm-trainer-eintrag {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.tm-trainer-foto {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
}

.tm-trainer-label {
  font-size: 0.65rem;
  color: rgba(255, 255, 255, 0.7);
}

.tm-trainer-name {
  font-size: 0.78rem;
  color: #fff;
  font-weight: 600;
}

.tm-tl-title-empty {
  text-align: center;
  color: var(--tm-muted);
  padding: 1.5rem 1rem;
  font-size: 0.9rem;
}

.tm-wechsel-tor {
  font-size: 0.85rem;
}

.ts-tag-nav__label--klickbar,
.tm-day-nav__label--klickbar {
  background: none;
  border: none;
  font-family: 'Poppins', sans-serif;
  font-weight: normal;
  font-size: 0.85rem;
  text-align: center;
  cursor: pointer;
  color: inherit;
  padding: 0.2rem 0.4rem;
  border-radius: 6px;
  width:112px;
  display:flex;
  flex-direction:column;
  align-items: center;
}

.tm-day-nav__label--klickbar:hover {
  background: var(--tm-surface-alt);
}

.tm-kalender-popover {
  position: absolute;
  top: calc(100% + 0.4rem);
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  background: var(--tm-surface);
  border: 1px solid var(--tm-border);
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(16, 24, 30, 0.15);
  padding: 0.75rem;
  width: 340px;
}

.tm-kalender-popover--teleportiert {
  position: fixed;
  top: 0;
  left: 0;
  transform: translateX(-50%);
  max-width: calc(100vw - 1.5rem);
}

.tm-kalender-backdrop {
  position: fixed;
  inset: 0;
  z-index: 99;
  background: transparent;
}

.tm-kalender-auf-enter-active,
.tm-kalender-auf-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}
.tm-kalender-auf-enter-from,
.tm-kalender-auf-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-6px);
}

.tm-kalender__kopf {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}

.tm-kalender__monat {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 0.9rem;
  text-transform: capitalize;
}

.tm-kalender__wochentage {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  font-size: 0.68rem;
  color: var(--tm-muted);
  margin-bottom: 0.3rem;
}

.tm-kalender__tage {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0.15rem;
}

.tm-kalender__tag {
  position: relative;
  min-height: 3.4rem;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 0.2rem;
  padding: 0.25rem 0.15rem;
  border: none;
  background: none;
  border-radius: 8px;
  font-size: 0.85rem;
  color: var(--tm-border);
  cursor: default;
  overflow: hidden;
}

.tm-kalender__tag--anderer-monat {
  opacity: 0.35;
}

.tm-kalender__tagnummer {
  line-height: 1;
}

.tm-kalender__badges {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1px;
  width: 100%;
}

.tm-kalender__badge {
  font-size: 0.62rem;
  line-height: 1.25;
  padding: 0.05rem 0.25rem;
  border-radius: 4px;
  background: var(--tm-accent-soft);
  color: var(--tm-accent);
  font-weight: 600;
  max-width: 100%;
  box-sizing: border-box;
  white-space: normal;
  overflow-wrap: anywhere;
  text-align: center;
}

.tm-kalender__badge--mehr {
  background: var(--tm-surface-alt);
  color: var(--tm-muted);
}

.tm-kalender__tag--aktiv .tm-kalender__badge {
  background: rgba(255, 255, 255, 0.25);
  color: var(--tm-accent-ink);
}

.tm-kalender__tag--leer {
  visibility: hidden;
}

.tm-kalender__tag--spiel {
  color: var(--tm-ink);
  cursor: pointer;
  font-weight: 500;
}

.tm-kalender__tag--spiel:hover {
  background: var(--tm-surface-alt);
}

.tm-kalender__tag--aktiv {
  background: var(--tm-accent) !important;
  color: var(--tm-accent-ink) !important;
}

.tm-kalender__tag--heute:not(.tm-kalender__tag--aktiv) {
  border: 1px solid var(--tm-accent);
}

.tm-card--favorit {
  border-left-color: #F5C518;
}

.tm-favorit-btn {
  border: none;
  background: none;
  color: var(--tm-border);
  font-size: 1rem;
  line-height: 1;
  cursor: pointer;
  padding: 0 0.15rem;
  flex-shrink: 0;
}

.tm-favorit-btn--aktiv {
  color: #F5C518;
}

.tm-kopf-btn, .tm-teilen-btn {
  width: 36px; height: 36px; flex: none;
  display: inline-grid; place-items: center;
  border-radius: 12px;
  border: 1px solid color-mix(in srgb, currentColor 18%, transparent);
  background: transparent; color: inherit;
  text-decoration: none; cursor: pointer;
}
.tm-kopf-btn:hover,
.tm-teilen-btn:hover { background: color-mix(in srgb, currentColor 8%, transparent); }

.tm-statistik { --tm-heim: #1d9e75; --tm-aus: #e8833a; }

.tm-stat-kopfblock { background: color-mix(in srgb, currentColor 5%, transparent); border-radius: 18px; padding: 12px 14px; margin-bottom: 14px; }
.tm-stat-label2 { text-align: center; font-size: 12px; font-weight: 700; opacity: .65; margin-bottom: 3px; }

.tm-stat-bar { display: flex; gap: 3px; height: 28px; font-variant-numeric: tabular-nums; }
.tm-stat-seg { display: flex; align-items: center; min-width: 38px; padding: 0 11px; font-weight: 800; font-size: 14px; animation: tm-stat-wachsen .6s ease-out both; }
.tm-stat-seg--h { --c: var(--tm-heim); border-radius: 14px 5px 5px 14px; justify-content: flex-start; transform-origin: left; }
.tm-stat-seg--a { --c: var(--tm-aus);  border-radius: 5px 14px 14px 5px; justify-content: flex-end; transform-origin: right; }
.tm-stat-seg.is-lead { background: var(--c); color: #fff; }
.tm-stat-seg.is-lag  { background: color-mix(in srgb, var(--c) 20%, transparent); color: var(--c); }
@keyframes tm-stat-wachsen { from { transform: scaleX(0); } }
@media (prefers-reduced-motion: reduce) { .tm-stat-seg { animation: none; } }

.tm-stat-xg { margin-top: 12px; padding-top: 10px; border-top: 1px solid color-mix(in srgb, currentColor 12%, transparent); text-align: center; }
.tm-stat-xg__zahlen { display: flex; justify-content: center; align-items: baseline; gap: 16px; font-variant-numeric: tabular-nums; }
.tm-stat-xg__z { font-size: 34px; font-weight: 800; letter-spacing: -.02em; }
.tm-stat-xg__z--h { color: var(--tm-heim); }
.tm-stat-xg__z--a { color: var(--tm-aus); }
.tm-stat-xg__z--lag { opacity: .4; }
.tm-stat-xg__t { opacity: .3; font-size: 22px; }

.tm-stat-gruppe { display: grid; gap: 9px; margin-bottom: 14px; }
.tm-stat-gruppe__titel { display: flex; align-items: center; gap: 10px; font-size: 10.5px; letter-spacing: .14em; text-transform: uppercase; font-weight: 800; opacity: .6; }
.tm-stat-gruppe__titel::after { content: ""; flex: 1; height: 1px; background: currentColor; opacity: .25; }

.tm-favoriten-filter-btn {
  border: 1px solid var(--tm-border);
  border-radius: 8px;
  background: var(--tm-surface);
  color: var(--tm-muted);
  font-family: inherit;
  font-size: 0.78rem;
  font-weight: 500;
  padding: 0.4rem 0.7rem;
  cursor: pointer;
  white-space: nowrap;
}

.tm-favoriten-filter-btn--aktiv {
  background: #FFF8E1;
  border-color: #F5C518;
  color: #8a6d00;
}

.tm-menu-btn {
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--tm-border);
  border-radius: 8px;
  background: var(--tm-surface);
  color: var(--tm-muted);
  cursor: pointer;
  flex-shrink: 0;
}

.tm-menu-btn:hover {
  border-color: var(--tm-accent);
  color: var(--tm-accent);
}

.tm-menue-liste {
  display: flex;
  flex-direction: column;
}

.tm-menue-eintrag {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0.8rem 0.4rem;
  border: none;
  border-bottom: 1px solid var(--tm-border);
  background: none;
  text-align: left;
  cursor: pointer;
  font-family: inherit;
}

.tm-menue-eintrag:last-child {
  border-bottom: none;
}

.tm-menue-eintrag:hover {
  background: var(--tm-surface-alt);
}

.tm-menue-eintrag__icon {
  font-size: 1.1rem;
  width: 1.5rem;
  text-align: center;
  flex-shrink: 0;
}

.tm-menue-eintrag__text {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  min-width: 0;
  text-align: left;
}

.tm-menue-eintrag__label {
  flex: 1;
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--tm-ink);
}

.tm-menue-eintrag__hinweis {
  font-size: 0.72rem;
  color: var(--tm-muted);
  font-weight: 400;
}

.tm-menue-eintrag__pfeil {
  color: var(--tm-muted);
  font-size: 1.1rem;
}

.tm-menue-schalter {
  width: 38px;
  height: 22px;
  border-radius: 999px;
  background: var(--tm-border);
  position: relative;
  flex-shrink: 0;
  transition: background 0.15s ease;
}

.tm-menue-schalter__knopf {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  transition: transform 0.15s ease;
}

.tm-menue-schalter--an {
  background: var(--tm-accent);
}

.tm-menue-schalter--an .tm-menue-schalter__knopf {
  transform: translateX(16px);
}

.tm-tabelle-tab {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  width: 100%;
  max-width: 500px;
  margin: 0px auto;
}

.tm-tabelle-tab .tm-scroll-bereich {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.tm-tabelle-block {
  margin-bottom: 1rem;
}

.tm-tabelle__gruppentitel {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 0.85rem;
  margin: 0 0 0.4rem;
  color: var(--tm-ink);
}

.tm-tabelle__liga-logo {
  width: 34px;
  height: 34px;
  object-fit: contain;
  flex-shrink: 0;
}

.tm-tabelle__kopf-info {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  min-width: 0;
}

.tm-tabelle__kopf-texte {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  min-width: 0;
}

.tm-tabelle__kopf-label {
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--tm-muted);
}

.tm-tabelle__kopf-liga {
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  font-size: 1.05rem;
  color: var(--tm-ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tm-tabelle {
  display: flex;
  flex-direction: column;
  font-size: 0.78rem;
}

.tm-tabelle__kopfzeile,
.tm-tabelle__zeile {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  padding: 0.3rem 0.2rem;
}

.tm-tabelle__kopfzeile {
  font-size: 0.68rem;
  color: var(--tm-muted);
  border-bottom: 1px solid var(--tm-border);
  text-transform: uppercase;
}

.tm-tabelle__zeile {
  border-bottom: 1px solid var(--tm-border);
}

.tm-tabelle__zeile--hervorgehoben {
  background: var(--tm-accent-soft);
  font-weight: 600;
}

.tm-tabelle__namenzeile {
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

.tm-tabelle__rang {
  flex: 0 0 1.1rem;
  text-align: center;
  color: var(--tm-muted);
}

.tm-tabelle__logo-platz {
  flex: 0 0 1.1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tm-tabelle__logo-platz img {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.tm-tabelle__name {
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
}

.tm-tabelle__zahlenzeile {
  display: flex;
  flex-wrap: nowrap;
  gap: 0.2rem;
  margin-left: calc(1.1rem + 0.3rem + 1.1rem + 0.3rem);
  font-size: 13px;
}

.tm-tabelle__zahl {
  flex: 1 1 0;
  min-width: 0;
  text-align: center;
  font-variant-numeric: tabular-nums;
}

.tm-tabelle__zahl:nth-child(5) {
  flex-grow: 1.4;
}

.tm-tabelle__zahl--punkte {
  font-weight: 700;
  color: var(--tm-accent);
}

.tm-vorschau__text {
  font-size: 0.9rem;
  line-height: 1.6;
  color: var(--tm-ink);
}

.tm-vorschau__text p {
  margin: 0 0 0.75rem;
}

.tm-vorschau__text p:last-child {
  margin-bottom: 0;
}

.tm-wechsel-seite {
  display: flex;
}

.tm-event-seite--heim.tm-wechsel-seite {
  justify-content: flex-start;
}

.tm-event-seite--auswaerts.tm-wechsel-seite {
  justify-content: flex-end;
}

.tm-wechsel-eintrag {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  flex-wrap: wrap;
  min-width: 0;
}

.tm-wechsel-paar {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  padding: 0.15rem 0;
}

.tm-wechsel-minute {
  font-size: 0.68rem;
  color: var(--tm-muted);
  font-weight: 600;
}

.tm-wechsel-rein {
  color: #1a8f4c;
  font-weight: 600;
}

.tm-wechsel-raus {
  color: var(--tm-muted);
}

.tm-card__footer-rechts {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.tm-card__flagge {
  font-size: 1.4rem;
  line-height: 1;
  flex-shrink: 0;
}

.tm-card__flagge--large {
  font-size: 1.7rem;
}

.tm-card__flagge--xl {
  font-size: 2rem;
}

@media (max-width: 640px) {
  .tm-toolbar {
    display: grid;
    grid-template-columns: 1fr auto auto;
    grid-template-areas:
      "search toggle menu"
      "select select select";
    align-items: center;
  }

  .tm-search {
    grid-area: search;
    min-width: 0;
  }

  .tm-toggle {
    grid-area: toggle;
    margin-left: 0;
  }

  .tm-menu-btn {
    grid-area: menu;
  }

  .tm-liga-dropdown__trigger {
    grid-area: select;
    width: 100%;
    max-width: none;
    flex: none;
  }
}

.tm-card__flagge-bild {
  width: 26px;
  height: auto;
  flex-shrink: 0;
  border-radius: 2px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);
}

.tm-card__flagge-bild--large {
  width: 34px;
}

.tm-card__flagge-bild--xl {
  width: 42px;
}

.ts-app {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  color: var(--tm-ink);
}

.ts-scroll-bereich {
  flex: 1;
  min-height: 0;
  overflow-y: hidden;
  overflow-x: hidden;
  display:flex;
}

.ts-spiele-bereich {
  display: flex;
  flex-direction: column;
  width:100%;
}

.ts-tag-nav {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0.5rem;
}

.ts-tag-nav-1 {
  flex:1;
  display:flex;
  align-items:center;
}

.ts-tag-nav__btn {
  width: 1.8rem;
  height: 1.8rem;
  border: 1px solid var(--tm-border);
  border-radius: 6px;
  background: var(--tm-surface);
  color: var(--tm-ink);
  font-size: 1rem;
  cursor: pointer;
  flex-shrink: 0;
}

.ts-tag-nav__label {
  width:70px;
  text-align: center;
  font-size: 0.82rem;
  font-weight: normal;
}

.ts-tag-nav__heute {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--tm-accent);
  background: var(--tm-accent-soft);
  color: var(--tm-accent);
  border-radius: 6px;
  font-size: 0.85rem;
  line-height: 1;
  cursor: pointer;
}

.ts-state {
  color: var(--tm-muted);
  font-size: 0.85rem;
  text-align: center;
  padding: 1.5rem 0;
}

.ts-tag-nav__gameplan {
  background-color: #1a2d4a;
  border:none;
  border-radius: 7px;
  font-size: 12px;
  color: silver;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding:7px 13px;
  margin-left:10px;
}

.ts-tag-nav__raster {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--tm-border);
  border-radius: 6px;
  background: var(--tm-accent-soft);
  color: var(--tm-accent);
  font-size: 0.85rem;
  line-height: 1;
  cursor: pointer;
}

.ts-spiele-liste {
  display: flex;
  flex:1;
  flex-direction: column;
  border: 1px solid var(--tm-border);
  border-radius: 10px;
  overflow-y: auto;
  overflow-x: hidden;
  background: var(--tm-surface);
  scrollbar-width: thin;
}

.ts-spiel-zeile {
  padding: 3px 5px;
  border-bottom: 1px solid var(--tm-border);
}

.ts-spiel-zeile:last-child {
  border-bottom: none;
}

.ts-spiel-zeile--live {
  background: var(--tm-live-soft);
}

.ts-spiel-zeile--gesperrt {
  opacity: 0.5;
}

.ts-spiel-zeit {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.68rem;
  color: var(--tm-muted);
  margin-bottom: 0.15rem;
}

.ts-live-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--tm-live);
  flex-shrink: 0;
  animation: tm-pulse 1.4s ease-in-out infinite;
}

.ts-spiel-liga {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  border: 1px solid var(--tm-surface-alt);
  color: var(--tm-accent);
  padding: 0.03rem 0.35rem;
  border-radius: 4px;
  font-size:11px;
  font-weight: 600;
}

.ts-spiel-flagge {
  width: 18px;
  height: auto;
  flex-shrink: 0;
  border-radius: 2px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);
}

.ts-spiel-gesperrt-hinweis {
  margin-left: auto;
}

.ts-spiel-teams {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.82rem;
}

.ts-spiel-team {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ts-spiel-teamname {
  flex:1;
}

.ts-spiel-team--heim .ts-spiel-teamname {
  text-align:right;
}

.ts-spiel-team--auswaerts {
  justify-content: flex-end;
}

.ts-spiel-logo {
  width: 24px;
  height: 24px;
}

.ts-spiel-mitte {
  flex-shrink: 0;
  font-size: 0.72rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: var(--tm-ink);
  min-width: 3.2rem;
  text-align: center;
}

.ts-spiel-mitte--countdown {
  font-weight: 400;
}

.ts-spiel-zeit-wert {
  font-weight: 700;
  font-size:11px;
}

.ts-spiel-mitte--beendet {
  font-size:17px;
  letter-spacing:3px;
}

.tm-karte-btn {
  margin-left: auto;
  display: inline-flex; align-items: center; justify-content: center; gap: 6px;
  height: initial; padding: 3px 12px;
  border-radius: 999px;
  border: 1.5px solid color-mix(in srgb, currentColor 25%, transparent);
  background: transparent; color: inherit;
  font: inherit; font-size: 13px; font-weight: 700; line-height: 1;
  cursor: pointer; white-space: nowrap;
  transition: background .15s, transform .1s;
}
.tm-karte-btn span {
  display:none;
}
.tm-karte-btn:hover { background: color-mix(in srgb, currentColor 8%, transparent); }
.tm-karte-btn:active { transform: scale(.96); }

.tm-karte-btn--story {
  background: var(--tm-btn-bg, #1b6a9c);
  border-color: var(--tm-btn-bg, #1b6a9c);
  color: #fff;
  box-shadow: 0 2px 8px color-mix(in srgb, var(--tm-btn-bg, #1b6a9c) 40%, transparent);
}
.tm-karte-btn--story:hover { background: color-mix(in srgb, var(--tm-btn-bg, #1b6a9c) 88%, #000); }


/* ---------- Bet-Man Story-Detail-Overlay (eigenständiges Branding, nicht das generische
   DetailOverlay) - liegt hier statt in einem scoped <style>, weil das Overlay per Teleport in
   den GEMEINSAMEN Portal-Shadow-Root wandert (siehe getPortalTarget()), wo nur diese
   style.css injiziert wird - ein scoped <style> in der .vue-Datei würde dort NICHT ankommen. */
 
.betman-detail-overlay {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000000;
  background: var(--tm-surface);
  border-radius: 16px 16px 0 0;
  max-height: 88vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 -4px 24px rgba(16, 24, 30, 0.2);
  font-family: 'Inter', system-ui, sans-serif;
  max-width: 800px;
  margin: 0 auto; 
}

.betman-detail-overlay__links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: .5rem;
  margin-top: 1.25rem;
  padding-top: 1rem;
  border-top: 1px solid color-mix(in srgb, currentColor 15%, transparent);
}
.betman-detail-overlay__link {
  padding: .4rem .8rem;
  border: 1px solid color-mix(in srgb, currentColor 25%, transparent);
  border-radius: 999px;
  font-size: .85rem;
  color: inherit;
  text-decoration: none;
}
.betman-detail-overlay__link:hover { background: color-mix(in srgb, currentColor 8%, transparent); }
 
.betman-detail-overlay__schliessen {
  position: absolute;
  top: 0.6rem;
  right: 0.6rem;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.06);
  color: #16232B;
  cursor: pointer;
  z-index: 1;
}
 
.betman-detail-overlay__scroll {
  overflow-y: auto;
  padding: 1rem 1.25rem 1.5rem;
}
 
.betman-detail-overlay__titel {
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  font-size: 1.2rem;
  line-height: 1.3;
  color: #16232B;
  margin: 6px 0px 15px 0px;
}

/* ---------- Hero-Bild + Badge-Stempel ---------- */

.betman-detail-overlay__hero {
  margin-bottom: 1.4rem;
  overflow: hidden;
}

.betman-detail-overlay__hero-sub {
  position: relative;
  border-radius: 12px;
  position: relative;
  max-width: 600px;
  margin: 0px auto;
}

.betman-detail-overlay__maskottchen {
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 12px;
  display: block;
}

.betman-detail-overlay__badge {
  background: #16232B;
  color: #fff;
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  padding: 0.3rem 0.7rem;
  border-radius: 999px;
}

.betman-detail-overlay__badge--stempel {
  position: absolute;
  right: 5px;
  top: 5px;
  background: rgba(22, 35, 43, 0.85);
  backdrop-filter: blur(2px);
}

/* ---------- Team-Matchup-Zeile ---------- */

.betman-detail-overlay__matchup {
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.betman-detail-overlay__team {
  display: flex;
  align-items: flex-end;
  flex:1;
  flex-direction: column;
  gap: 0.4rem;
  min-width: 0;
}

.betman-detail-overlay__team--auswaerts {
  flex-direction: column-reverse;
  align-items: flex-start;
}

.betman-detail-overlay__team-logo {
  width: 24px;
  height: 24px;
  object-fit: contain;
  flex-shrink: 0;
}

.betman-detail-overlay__team-name {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #16232B;
  overflow: hidden;
  text-overflow: ellipsis;
}

.betman-detail-overlay__matchup-trenner {
  color: #6B756E;
  font-weight: 500;
  flex-shrink: 0;
  width:20px;
  text-align:center;
}

.betman-detail-overlay__matchup-trenner--ergebnis {
  width:50px;
  letter-spacing:5px;
  margin-top:3px;
  margin-right:-5px;
  font-weight: bold;
  color: var(--gold);
}

/* ---------- Meta-Zeile (Zeit + Erstellt-Datum zusammengefasst) ---------- */

.betman-detail-overlay__meta-zeile {
  font-size: 0.72rem;
  color: #6B756E;
  margin-bottom: 0.6rem;
}

.betman-detail-overlay__datum {
  font-size: 0.8rem;
  color: #6B756E;
}
 
.betman-detail-overlay__ergebnis {
  font-size: 0.85rem;
  font-weight: 700;
  color: #16232B;
}
 
.betman-detail-overlay__quoten {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

.betman-detail-overlay__quote-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.15rem;
  background: #fff;
  border-radius: 8px;
  padding: 0.3rem 0.4rem;
  box-shadow: 0 1px 2px rgba(22, 35, 43, 0.08);
  border: 1px solid #e0e0e0;
  max-width:120px;
}

.betman-detail-overlay__quote-box.quote-box-x {
  width:70px;
  max-width:initial;
  flex: initial;
}
 
.betman-detail-overlay__quote-box--beste {
  background: #DCEFE1;
}
 
.betman-detail-overlay__quote-box--beste .betman-detail-overlay__quote-wert {
  color: #1a5c38;
}
 
.betman-detail-overlay__quote-label {
  font-size: 0.8rem;
  color: #4A5A64;
  line-height: initial;
}
 
.betman-detail-overlay__quote-wert {
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  font-size: 0.95rem;
  color: #16232B;
}
 
.betman-detail-overlay__text {
  font-size: 0.95rem;
  font-weight:normal;
  line-height: 1.6;
  color: #16232B;
  margin: 0 0 1rem;
  white-space: pre-line;
}
 
.betman-detail-overlay__tipp-box {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  background: #DCEFE1;
  border-radius: 10px;
  padding: 0.75rem 0.9rem;
}
 
.betman-detail-overlay__tipp-icon {
  font-size: 1.2rem;
  flex-shrink: 0;
}

.betman-detail-overlay__tipp-icon svg {
  width:50px;
}
 
.betman-detail-overlay__tipp-label {
  font-size: 0.78rem;
  color: #2F7A52;
  margin-bottom: 0.15rem;
}
 
.betman-detail-overlay__tipp-text {
  font-weight: 700;
  color: #1a5c38;
  font-size: 0.95rem;
}

@media (max-width: 400px) {
  .betman-detail-overlay__scroll {
    padding:13px 10px 13px 10px;
  }
  /* Bild unter 400px begrenzen + zentrieren statt volle Breite - wirkt auf sehr schmalen
     Screens sonst überproportional dominant. */
  .betman-detail-overlay__hero {
    /*max-width: 300px;
    margin-left: auto;
    margin-right: auto;*/
  }
}

.tm-sheet-griff {
  width:100%;
  min-height: 29px;
  margin: 0px auto 10px auto;
  padding-top:5px;
  touch-action: none;
  cursor: grab;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.tm-sheet-griff-inner {
  height: 6px;
  width:40px;
  border-radius: 2px;
  background: var(--tm-border);
}

/* ---------- Schließen-Button in Sheet-Overlays - zusätzlich zu .tm-vollbild-btn, NICHT dieses
   selbst verändern (wird auch als Vollbild-Umschalter in der normalen Toolbar genutzt, dort
   als normales Flex-Item, nicht absolut positioniert). Rechts oben, auf Höhe des Zieh-Griffs. */
.tm-sheet-griff__schliessen {
  position: absolute;
  top: 50%;
  right: 3px;
  transform: translateY(-50%);
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--tm-border);
  border-radius: 8px;
  background: var(--tm-surface);
  color: var(--tm-muted);
  cursor: pointer;
  z-index: 1;
}
 
.tm-sheet-griff__schliessen:hover {
  color: var(--tm-accent);
  border-color: var(--tm-accent);
}

.tm-liga-mini-toggle {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--tm-border);
  border-radius: 6px;
  background: var(--tm-surface);
  font-size: 0.85rem;
  line-height: 1;
  cursor: pointer;
  opacity: 0.4;
  filter: grayscale(1);
}

.tm-liga-mini-toggle--aktiv {
  opacity: 1;
  filter: none;
  border-color: #F5C518;
  background: #FFF8E1;
}

.tm-kalender__punkte {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 3px;
  max-width: 100%;
  padding: 0 2px;
}

.tm-kalender__punkt {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}

.tm-kalender__punkt--top5 {
  background: var(--tm-accent);
}

.tm-kalender__punkt--europapokal {
  background: #8B5CF6;
}

.tm-kalender__punkt--nationalmannschaft {
  background: #F59E0B;
}

.tm-kalender__punkt--sonstige {
  background: var(--tm-muted);
}

.tm-kalender__tag--aktiv .tm-kalender__punkt {
  background: rgba(255, 255, 255, 0.85);
}

/* ---------- Vollbild-Übersicht aller Betman-Stories ---------- */
 
.betman-uebersicht {
  position: fixed;
  inset: 0;
  z-index: 999998; /* NIEDRIGER als tm-detail-overlay (1000000) - das Detail soll sich beim
                       Öffnen einer Story darüber legen, nicht dahinter verschwinden */
  background: var(--tm-surface, #fff);
  display: flex;
  flex-direction: column;
}

.betman-uebersicht__wochen-btn:hover {
  border-color: var(--tm-accent, #0B6E9E);
  color: var(--tm-accent, #0B6E9E);
}

.betman-uebersicht__wochen-label {
  font-weight: 600;
  font-size: 0.9rem;
  color: var(--tm-ink, #16232B);
  min-width: 90px;
  text-align: center;
}

.betman-uebersicht__suche-zeitraum {
  display: flex;
  gap: 6px;
  margin-top: 6px;
}

.betman-uebersicht__suche-zeitraum-input {
  flex: 1;
  padding: 0.35rem 0.6rem;
  border: 1px solid var(--tm-border, #B9CBD3);
  border-radius: 6px;
  font-family: inherit;
  font-size: 0.75rem;
  background: var(--tm-surface, #fff);
  color: var(--tm-ink, #16232B);
}

.betman-uebersicht__kopf {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.85rem 1rem;
  border-bottom: 1px solid var(--tm-border, #B9CBD3);
  flex-shrink: 0;
}
 
.betman-uebersicht__titel {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 1.1rem;
  color: var(--tm-ink, #16232B);
}
 
.betman-uebersicht__schliessen {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--tm-border, #B9CBD3);
  border-radius: 8px;
  background: var(--tm-surface, #fff);
  color: var(--tm-muted, #4A5A64);
  cursor: pointer;
  flex-shrink: 0;
}
 
.betman-uebersicht__schliessen:hover {
  color: var(--tm-accent, #0B6E9E);
  border-color: var(--tm-accent, #0B6E9E);
}
 
.betman-uebersicht__liste-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}
 
.betman-uebersicht__liste {
  padding: 0px 1rem 1rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(165px, 1fr));
  gap: 10px;
  @media (max-width: 400px) {
    padding-left:7px;
    padding-right:7px;
  }
}
 
/* .story-card hat sonst eine fixe Breite (170px, passend für die horizontal scrollende Reihe) -
   innerhalb des Grids soll die Karte stattdessen die volle Zellenbreite ausfüllen, sonst bliebe
   in breiteren Grid-Zellen Leerraum stehen. */
.betman-uebersicht__liste .story-card-erw {
  width: 100%;
}
 
/* ---------- Trigger-Button am Ende der Story-Reihe ---------- */
 
.story-row__alle-wrapper {
  position: sticky;
  left: 0;
  z-index: 1;
  flex-shrink: 0;
  align-self: stretch;
  display: flex;
  align-items: center;
  padding: 0px;
}

.story-row-fade-enter-active {
  transition: opacity 0.45s ease, transform 0.45s ease;
}

.story-row-fade-enter-from {
  opacity: 0;
  transform: translateY(6px);
}

.story-row-fade-enter-to {
  opacity: 1;
  transform: translateY(0);
}

.betman-uebersicht__aktuell-btn {
  padding: 0.35rem 0.7rem;
  border: 1px solid var(--tm-accent, #0B6E9E);
  border-radius: 999px;
  background: var(--tm-surface, #fff);
  color: var(--tm-accent, #0B6E9E);
  font-family: inherit;
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  margin-left: 4px;
}
 
.betman-uebersicht__aktuell-btn:hover {
  background: var(--tm-accent, #0B6E9E);
  color: #fff;
}
 
.story-row__alle-btn {
  flex-shrink: 0;
  width: 60px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  border: 1px dashed rgba(255, 255, 255, 0.3);
  border-radius: 10px;
  background: none;
  color: #fff;
  cursor: pointer;
  font-family: inherit;
}
 
.story-row__alle-icon {
  font-size: 1.1rem;
  line-height: 1;
}
 
.story-row__alle-label {
  font-size: 10px;
  font-weight: 600;
}
 
.betman-uebersicht__filter {
  display: flex;
  gap: 6px;
  padding: 0.75rem 1rem 0;
  flex-shrink: 0;
}
 
.betman-uebersicht__filter-btn {
  padding: 0.4rem 0.8rem;
  border: 1px solid var(--tm-border, #B9CBD3);
  border-radius: 999px;
  background: var(--tm-surface, #fff);
  color: var(--tm-ink, #16232B);
  font-family: inherit;
  font-size: 0.78rem;
  font-weight: 500;
  cursor: pointer;
}
 
.betman-uebersicht__filter-btn--aktiv {
  background: var(--tm-accent, #0B6E9E);
  border-color: var(--tm-accent, #0B6E9E);
  color: #fff;
}
 
/* ---------- Story-Karte (BetmanStoryCard.vue) - hierher verschoben statt <style scoped>
   in der Komponente selbst, weil scoped-Styles bei defineCustomElement NICHT automatisch
   ins Shadow DOM gelangen (die landen normalerweise im <head>, aber das Shadow Root
   bekommt nur, was explizit über styles:[styles] in register.js reingereicht wird -
   also diese gemeinsame style.css-Datei). ---------- */
 
.story-card {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: var(--tm-surface, #FFFFFF);
  border: 1px solid var(--tm-border, #B9CBD3);
  border-radius: 10px;
  padding: 3px 5px;
  text-align: left;
  font-family: inherit;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}
 
.story-row .story-card {
  width: 180px;
}

.story-card:hover {
  border-color: var(--tm-accent, #0B6E9E);
  background: var(--tm-surface-alt, #CFE9F3);
}
 
.story-card__kopf {
  display: flex;
  align-items: center;
  gap: 5px;
}
 
.story-card__live-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--tm-live, #C8432A);
  flex-shrink: 0;
  animation: story-card-pulse 1.4s ease-in-out infinite;
}
 
@keyframes story-card-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.35; }
}
 
.story-card__flagge {
  width: 19px;
  height: auto;
  flex-shrink: 0;
  border-radius: 2px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);
}
 
.story-card__phase {
  font-size: 8px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--tm-muted, #4A5A64);
  flex-shrink: 0;
  border-radius:4px;
  padding:1px 3px;
}

/* GEÄNDERT: statt reinem grauen Text jetzt farbige Pillen pro Kategorie - schnellere visuelle
   Unterscheidung auf einen Blick, besonders wichtig jetzt, wo mehr als nur Vorschau/Bericht
   möglich sind (story/rumor, künftig auch Fakten/Skandal/Transfer etc.). */
.story-card__phase--preview {
  background: #0B6E9E; /* Blau - bevorstehend */
  color:white;
}
 
.story-card__phase--report {
  background: #2F7A52; /* Grün - abgeschlossen/ausgewertet */
  color:white;
}
 
.story-card__phase--story {
  background: #7C4DFF; /* Violett - redaktionelle Story */
  color:white;
}
 
.story-card__phase--rumor {
  background: #C8432A; /* Rot-Orange - Gerücht, bewusst "vorsichtiger" Farbton */
}
 
.story-card__neu {
  background: var(--tm-live, #C8432A);
  color: #fff;
  font-size: 7px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  padding: 1px 5px;
  border-radius: 999px;
  flex-shrink: 0;
  margin-left: 4px;
  line-height: 1.5;
}
 
.story-card__spacer {
  flex: 1;
  min-width: 4px;
}
 
.story-card__label {
  font-size: 11px;
  font-weight: 500;
  color: var(--tm-ink, #16232B);
  line-height: 1.3;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
   -webkit-box-orient: vertical;
  overflow: hidden;
}
 
.story-card__info {
  font-size: 10px;
  font-weight: 700;
  color: var(--tm-accent, #0B6E9E);
  font-variant-numeric: tabular-nums;
  flex-shrink: 0;
  white-space: nowrap;
}
 
/* ---------- Story-Row-Container (BetmanStoryWidget.vue) - hierher verschoben, gleicher Grund
   wie bei BetmanStoryCard.vue: scoped-Styles der ROOT-Komponente, die via defineCustomElement
   registriert wird, landen NICHT automatisch im Shadow DOM. ---------- */
 
.story-row {
  display: flex;
  gap: 8px;
  overflow:hidden;
  padding: var(--tm-story-row-padding);
  background: var(--tm-story-row-bg);
  border-radius: var(--tm-story-row-border-radius);
}
.story-row--card-container {
  overflow-x: auto;
  display:flex;
  gap:8px;
  scrollbar-width: thin;
  scroll-snap-type: x proximity; /* proximity statt mandatory - snappt nur wenn nah dran, blockt
                                    nicht das freie Scrollen/Werfen mit dem Finger */
  scroll-behavior: smooth;
}
.story-row--card-container > * {
  scroll-snap-align: start;
}
.story-row > .tm-state {
  flex: 1;
  color: rgba(255, 255, 255, 0.7);
}
.story-card__flagge--large {
  width: 24px;
}
 
.story-card__flagge--xl {
  width: 30px;
}
 
.betman-uebersicht__suche {
  padding: 0.6rem 1rem 0.6rem;
  flex-shrink: 0;
}
 
.betman-uebersicht__suche-input {
  width: 100%;
  box-sizing: border-box;
  padding: 0.5rem 0.75rem;
  border: 1px solid var(--tm-border, #B9CBD3);
  border-radius: 8px;
  font-family: inherit;
  font-size: 0.85rem;
  background: var(--tm-surface, #fff);
  color: var(--tm-ink, #16232B);
}
 
.betman-uebersicht__suche-input:focus-visible {
  outline: 2px solid var(--tm-accent, #0B6E9E);
  outline-offset: 1px;
}
 
/* ---------- Erweiterte Story-Karte (BetmanStoryCardErweitert.vue) - NUR für die Übersicht.
   Nutzt einige der geteilten .story-card__*-Klassen (Live-Punkt/Flagge/Phase/Neu-Badge) weiter,
   hat aber eigene Klassen für Layout/Label/Info/Datum, da mehr Platz im Grid zur Verfügung
   steht als in der kompakten horizontalen Reihe. ---------- */
 
.story-card-erw {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0;
  background: var(--tm-surface, #FFFFFF);
  border: 1px solid var(--tm-border, #B9CBD3);
  border-radius: 10px;
  padding: 0;
  overflow: hidden;
  text-align: left;
  font-family: inherit;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}
 
.story-card-erw__bild {
  width: 100%;
  object-fit: cover;
  display: block;
}
 
.story-card-erw__inhalt {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 8px;
}
 
.story-card-erw:hover {
  border-color: var(--tm-accent, #0B6E9E);
  background: var(--tm-surface-alt, #CFE9F3);
}
 
.story-card-erw__kopf-sub {
  width:100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}

.story-card-erw__kopf-links {
  display: flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
  overflow: hidden;
  width:100%;
}

.story-card-erw__kopf-rechts {
  display: flex;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
  width:100%;
}

.story-card-erw__kopf-rechts-1 {
  flex:1;
  display: flex;
  align-items: center;
}

.story-card-erw__kopf-rechts-2 {
  display: flex;
  align-items: center;
}

.story-card-erw__label {
  font-size: 13px;
  font-weight: 500;
  color: var(--tm-ink, #16232B);
  line-height: 1.35;
}
 
.story-card-erw__info {
  font-size: 11px;
  font-weight: 700;
  color: var(--tm-accent, #0B6E9E);
  font-variant-numeric: tabular-nums;
  flex-shrink: 0;
  white-space: nowrap;
}
 
.story-card-erw__datum {
  font-size: 10px;
  color: var(--tm-muted, #4A5A64);
}
 
.story-card-erw__fusszeile {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  margin-top: 2px;
}
 
.story-card-erw__teilen-btn {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--tm-border, #B9CBD3);
  border-radius: 6px;
  background: var(--tm-surface, #fff);
  color: var(--tm-accent, #0B6E9E);
  font-size: 0.85rem;
  cursor: pointer;
}
 
.story-card-erw__teilen-btn:hover {
  background: var(--tm-surface-alt, #CFE9F3);
}
 
.betman-uebersicht__telegram-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0.4rem 0.7rem;
  border: 1px solid #229ED9;
  border-radius: 8px;
  background: #229ED9;
  color: #fff;
  font-size: 0.78rem;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  flex-shrink: 0;
}
 
.betman-uebersicht__telegram-btn:hover {
  background: #1b8bc0;
}
 
.story-card-erw__liga {
  flex:1;
  font-size: 10px;
  font-weight: 600;
  padding:2px 3px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--tm-accent, #0B6E9E);
  background: var(--tm-surface-alt, #CFE9F3);
  border-radius: 4px;
  flex-shrink: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ts-story-btn--story {
  background: var(--tm-accent, #0B6E9E);
  border-color: var(--tm-accent, #0B6E9E);
  color: #fff;
}

/* Ladespinner fürs StartseiteWidget (.ts-state) - rotierender Ring, gleiches Prinzip wie
   .tm-state__spinner an anderer Stelle im Projekt. */
.tm-state__spinner--startseite {
  width: 28px;
  height: 28px;
  border: 3px solid var(--tm-border, #B9CBD3);
  border-top-color: var(--tm-accent, #0B6E9E);
  border-radius: 50%;
  animation: ts-spinner-drehen 0.8s linear infinite;
  margin: 0 auto;
}
 
@keyframes ts-spinner-drehen {
  to { transform: rotate(360deg); }
}
 
/* ---------- Favoriten-Hinweis-Bubble (StartseiteWidget.vue) ---------- */
 
.ts-liga-fav-wrapper {
  position: relative;
  display: inline-flex;
}
 
.ts-liga-fav-hinweis {
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  width: 200px;
  background: var(--tm-ink, #16232B);
  color: #fff;
  font-size: 0.75rem;
  line-height: 1.4;
  padding: 0.5rem 0.7rem;
  border-radius: 8px;
  text-align: center;
  z-index: 5;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}
 
/* Kleines Dreieck, zeigt nach oben zum Button */
.ts-liga-fav-hinweis::before {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-bottom-color: var(--tm-ink, #16232B);
}

.betman-uebersicht__wochen-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 0.75rem 1rem 0;
  flex-shrink: 0;
}

.betman-uebersicht__wochen-btn {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--tm-border, #B9CBD3);
  border-radius: 8px;
  background: var(--tm-surface, #fff);
  color: var(--tm-ink, #16232B);
  font-size: 1rem;
  cursor: pointer;
}


/* ---------- "Meine Einschätzung" (betman_einschaetzung) in BetmanStoryBody.vue ---------- */
 
.betman-detail-overlay__einschaetzung {
  margin-bottom: 1rem;
}
 
.betman-detail-overlay__einschaetzung-titel {
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: #16232B;
  margin: 0 0 0.4rem;
}
 
.betman-detail-overlay__einschaetzung-text {
  font-size: 0.9rem;
  line-height: 1.55;
  color: #16232B;
  margin: 0;
}
 
.betman-detail-overlay__teilen-btn {
  position: absolute;
  top: 0.6rem;
  right: 3.2rem; /* links neben dem Schließen-Button (der bei right:0.6rem sitzt) */
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.06);
  color: #16232B;
  cursor: pointer;
  z-index: 1;
}
 
/* ---------- Kopf-Zeile in BetmanStoryDetail.vue - eigener Namespace statt tm-detail-overlay,
   da das hier der BETMAN-Overlay ist, nicht das generische Match-DetailOverlay ---------- */
 
.betman-detail-overlay__kopf {
  padding: 0 1.25rem;
  margin-bottom: 0.5rem;
}
 
.betman-detail-overlay__titel-kopf {
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  font-size: 1.05rem;
  color: #16232B;
}
 
/* ---------- Teilen-Button im DetailOverlay-Kopf (Vorschau/Bericht/Standalone-Story) ---------- */
 
.tm-detail-overlay__teilen-gruppe {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  margin-left: auto;
}
 
.tm-detail-overlay__telegram-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 0.85rem;
  text-decoration: none;
  cursor: pointer;
}
 
.tm-detail-overlay__teilen-btn,
.tm-detail-overlay__oeffnen-btn,
.tm-detail-overlay__telegram-btn {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--tm-border, #B9CBD3);
  border-radius: 8px;
  color: inherit;
  background: var(--tm-surface, #fff);
  font-size: 0.9rem;
  cursor: pointer;
  text-decoration: none;
}
 
.tm-detail-overlay__teilen-btn:hover,
.tm-detail-overlay__oeffnen-btn:hover,
.tm-detail-overlay__telegram-btn:hover {
  background: var(--tm-surface-alt, #CFE9F3);
}

.tm-detail-overlay__teilen-gruppe svg {
  display: block;
}

/* ---------- LiveTickerWidget.vue - minimaler Ergebnis+Zeit-Ticker ohne Teamnamen ---------- */
 
.tm-liveticker {
  background-color: var(--tm-liveticker-bg);
  display: inline-flex;
  align-items: center;
  font-family: 'Inter', system-ui, sans-serif;
}
 
.tm-liveticker__inhalt {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.tm-liveticker__ergebnis {
  font-family: 'Poppins', sans-serif;
  font-size: 1.3rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.tm-liveticker__inhalt .tm-liveticker__inhalt_1 {
  color:var(--tm-liveticker-color-1);
  letter-spacing: 5px;
  margin-right: -5px;
}
 
.tm-liveticker__inhalt .tm-liveticker__inhalt_2 {
  color:var(--tm-liveticker-color-2);
  display:flex;
  gap:6px;
  align-items: center;
}
 
.tm-liveticker__live-dot {
  display:inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--tm-live, #C8432A);
  flex-shrink: 0;
  animation: tm-liveticker-pulse 1.4s ease-in-out infinite;
}
 
@keyframes tm-liveticker-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.35; }
}
 
.tm-liveticker__status {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--tm-muted, #4A5A64);
}


.tm-ausfall-info { display: flex; flex-direction: column; gap: 2px; }
.tm-ausfall-grund { opacity: 0.7; font-size: 0.85em; }
.tm-ausfall-detail { font-size: 0.8em; opacity: 0.75; line-height: 1.3; }

.tm-h2h-tab {
  width: 100%;
  max-width: 500px;
  margin: 0px auto;
}
.tm-h2h-liste {
  display: flex;
  flex-direction: column;
}

.tm-h2h-zeile {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 4px;
  border-bottom: 1px solid #f0f0f0;
}
.tm-h2h-zeile:last-child {
  border-bottom: none;
}

.tm-h2h-links {
  flex: 1 1 0;
  min-width: 0;
}
.tm-h2h-liga {
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #c2600c;
  margin-bottom: 2px;
}
.tm-h2h-datum {
  font-size: 0.8rem;
  font-weight: 600;
  color: #555;
}
.tm-h2h-ort {
  font-size: 0.72rem;
  color: #9a9a9a;
  margin-top: 2px;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tm-h2h-rechts {
  flex: none;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.tm-h2h-team-zeile {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.85rem;
  color: #555;
}
.tm-h2h-team-zeile--sieger {
  color: #1a1a1a;
  font-weight: 700;
}
.tm-h2h-team-name {
  flex: 1;
  text-align: right;
}
.tm-h2h-team-tore {
  min-width: 20px;
  text-align: right;
  font-weight: 700;
}

.tm-h2h-leer {
  text-align: center;
  color: #9a9a9a;
  font-size: 0.85rem;
  padding: 16px 0;
}

.tm-fakten-liste {
  list-style: none;
  margin: 0;
  padding: 0;
}

.tm-fakten-liste li {
  position: relative;
  padding: 0.55rem 0.2rem 0.55rem 1.1rem;
  font-size: 0.85rem;
  line-height: 1.4;
  color: var(--tm-ink);
  border-bottom: 1px solid var(--tm-border);
}

.tm-fakten-liste li:last-child {
  border-bottom: none;
}

.tm-fakten-liste li::before {
  content: "";
  position: absolute;
  left: 0.2rem;
  top: 1.05rem;
  width: 0.4rem;
  height: 0.4rem;
  border-radius: 50%;
  background: var(--tm-muted);
}

.tm-fakten-tab {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
}

.tm-fakten-stand {
  margin-top: 0.8rem;
  font-size: 0.68rem;
  color: var(--tm-muted);
}

.tm-fakten-block + .tm-fakten-block { margin-top: 1.25rem; }
.tm-fakten-titel { margin: 0 0 .5rem; font-size: .8rem; font-weight: 600; letter-spacing: .04em; text-transform: uppercase; opacity: .7; }

.tm-spiele-tab { 
  display: flex; flex-direction: column; flex: 1 1 auto; min-height: 0; 
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
}
.tm-spiele-liste { list-style: none; margin: 0; padding: 0; }
.tm-spiele-eintrag--beendet { background:#f5f5f5; }
.tm-spiele-live-punkt {
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 5px;
  border-radius: 50%;
  background: #e5484d;
  animation: tm-live-puls 1.4s ease-in-out infinite;
}
@keyframes tm-live-puls {
  0%, 100% { opacity: 1; }
  50% { opacity: .35; }
}
@media (prefers-reduced-motion: reduce) {
  .tm-spiele-live-punkt { animation: none; }
}

.tm-sp-zeile { display: grid; grid-template-columns: 74px 1fr 44px; align-items: center; gap: 10px; width: 100%; padding: 8px 4px; border: 0; background: transparent; color: inherit; font: inherit; text-align: left; cursor: pointer; border-bottom: 1px solid color-mix(in srgb, currentColor 10%, transparent); }
.tm-sp-zeile--aktuell { background: color-mix(in srgb, currentColor 7%, transparent); border-radius: 8px; }

.tm-sp-zeit { display: flex; flex-direction: column; gap: 1px; font-variant-numeric: tabular-nums; white-space: nowrap; }
.tm-sp-datum { font-size: 12px; font-weight: 700; }
.tm-sp-uhr { font-size: 12px; opacity: .65; }

.tm-sp-teams { display: grid; gap: 3px; min-width: 0; }
.tm-sp-team { display: flex; align-items: center; gap: 8px; min-width: 0; font-size: 14px; }
.tm-sp-logo { flex: none; width: 20px; height: 20px; object-fit: contain; }
.tm-sp-name { flex: 1; min-width: 0; 
  overflow: hidden; text-overflow: ellipsis; 
  white-space: nowrap; letter-spacing: 0.03rem;}
.tm-sp-team--fokus { font-weight: 800; }
.tm-sp-team--gegner { opacity: .6; }
.tm-sp-tore { flex: none; min-width: 14px; text-align: center; font-weight: 800; font-variant-numeric: tabular-nums; }

.tm-sp-rechts { display: flex; flex-direction: column; align-items: center; gap: 4px; width: 44px; }
.tm-sp-ha { font-size: 10px; font-weight: 800; padding: 1px 6px; border-radius: 999px; background: color-mix(in srgb, currentColor 10%, transparent); }
.tm-sp-liga { width: 25px; height: auto; object-fit: contain; }
.tm-sp-flagge { width: 22px; height: 15px; object-fit: cover; border-radius: 2px; box-shadow: 0 0 0 1px color-mix(in srgb, currentColor 15%, transparent); }

/* ---- Raster-Modal ---- */
.tm-raster-nav { display: flex; align-items: center; gap: 4px; }
.tm-raster-titel { min-width: 110px; text-align: center; }
.tm-raster-pfeil { width: 36px; height: 36px; border-radius: 12px; border: 1px solid color-mix(in srgb, currentColor 18%, transparent); background: transparent; color: inherit; font-size: 20px; line-height: 1; cursor: pointer; }

.tm-raster-backdrop { position: fixed; inset: 0; z-index: 999999; /* unter dem Detail-Overlay (1000000) */ background: rgba(16, 24, 30, .45); display: flex; align-items: center; justify-content: center; padding: 12px; }
.tm-raster-modal { 
  display: flex;
  flex-direction: column;
  width: min(900px, 100%);
  height: min(88dvh, 720px);   /* fest, springt nicht mehr je nach Inhalt */
  background: var(--tm-surface);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(16, 24, 30, .25);
  overflow: hidden;
 }
.tm-raster-kopf { flex: none; display: flex; align-items: center; justify-content: space-between; padding: 12px 16px; }
.tm-raster-titel { font-size: 18px; font-weight: 800; }
.tm-raster-close { width: 36px; height: 36px; border-radius: 12px; border: 1px solid color-mix(in srgb, currentColor 18%, transparent); background: transparent; color: inherit; font-size: 15px; cursor: pointer; }
.tm-raster-inhalt { flex: 1; min-height: 0; overflow: auto; padding: 0 16px 16px; }

/* ---- Raster ---- */
.tm-raster__leer { padding: 24px; text-align: center; opacity: .6; }
.tm-raster__scroll { overflow-x: auto; }
.tm-raster__reihe { display: flex; gap: 24px; }
.tm-raster__tag { flex: 1; min-width: 0; }
.tm-raster__grid { display: grid; gap: 6px; align-items: start; }
.tm-raster__ecke { font-size: 12px; font-weight: 800; }
.tm-raster__kopf { --col: currentColor; font-size: 12px; font-weight: 800; letter-spacing: .04em; text-transform: uppercase; opacity: .65; padding: 0 2px 4px; border-bottom: 2px solid color-mix(in srgb, var(--col) 30%, transparent); }
.tm-raster__zeit { font-size: 12px; font-weight: 700; font-variant-numeric: tabular-nums; padding-top: 8px; opacity: .75; }
.tm-raster__zelle { display: grid; gap: 6px; min-width: 0; }

.tm-raster__karte { box-sizing: border-box; width: 100%; min-width: 0; display: grid; gap: 4px; padding: 8px 10px; border-radius: 10px; border: 1px solid color-mix(in srgb, currentColor 14%, transparent); background: color-mix(in srgb, currentColor 4%, transparent); cursor: pointer; }
.tm-raster__karte:focus-visible { outline: 2px solid currentColor; outline-offset: 2px; }
.tm-raster__karte--live { border-color: color-mix(in srgb, #e5484d 55%, transparent); }

.tm-raster__meta { display: flex; align-items: center; justify-content: space-between; gap: 6px; font-size: 11px; font-weight: 600; opacity: .8; min-height: 14px; }
.tm-raster__liga { display: flex; align-items: center; gap: 5px; min-width: 0; }
.tm-raster__liga span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.tm-raster__flagge { width: 14px; height: 10px; object-fit: cover; border-radius: 2px; flex: none; }
.tm-raster__meta-rechts { display: flex; align-items: center; gap: 6px; flex: none; }
.tm-raster__story { font-size: 12px; padding: 0 5px; border-radius: 999px; background: color-mix(in srgb, currentColor 14%, transparent); }
.tm-raster__badge { font-weight: 800; font-variant-numeric: tabular-nums; }
.tm-raster__karte--live .tm-raster__badge { color: #e5484d; }

.tm-raster__team { display: flex; align-items: center; gap: 8px; min-width: 0; }
.tm-raster__logo { flex: none; width: 24px; height: 24px; object-fit: contain; }
.tm-raster__name { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 14px; font-weight: 600; }
.tm-raster__tor { flex: none; min-width: 14px; text-align: right; font-size: 15px; font-weight: 800; font-variant-numeric: tabular-nums; }

.tm-kopf-liga { display: flex; align-items: center; gap: 10px; min-width: 0; }
.tm-kopf-liga__logo { width: 36px; height: 36px; object-fit: contain; flex: none; }
.tm-kopf-liga__texte { display: flex; flex-direction: column; line-height: 1.1; min-width: 0; }
.tm-kopf-liga__label { font-size: 11px; letter-spacing: .08em; text-transform: uppercase; opacity: .6; }
.tm-kopf-liga__name { font-size: 18px; font-weight: 800; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
